module.exports = __webpack_public_path__ + "static/template_options_week_grid_with_task_list-38d1c19f819a87d343215252b663249d.png";